module.exports = __webpack_public_path__ + "static/jaredPalmer-1d565c0579cb650ba07956fcd559beb6.jpg";